'use client';

import Cookies from 'js-cookie';

import { USER_TKN } from '@/slw/shared/consts/common.const';

export function saveTokenClient(token: string) {
  Cookies.set(USER_TKN, token, {
    secure: true, // Always secure for production
    sameSite: 'lax',
    path: '/',
    expires: 100, // 100 days
  });
}

export function clearTokenClient() {
  Cookies.remove(USER_TKN);
}

export function isLoggedInClient() {
  return !!Cookies.get(USER_TKN);
}

export function getTokenClient() {
  return Cookies.get(USER_TKN);
}
